export let OrderDetailsModalLayoutJSON = [
  {
    name: "Details",
    child: [
      // {
      //   child: [
      //     {
      //       child: [
      //         {
      //           parentid: "1718616922481-col-1",
      //           elementid: "1718616967444",
      //           elementtype: "textfield",
      //         },
      //       ],
      //       colpos: 1,
      //       parentid: "1718616922481-columns",
      //       elementid: "1718616922481-col-1",
      //       elementtype: "column",
      //       colsizeclass: "col-md-6",
      //     },
      //     {
      //       child: [
      //         {
      //           parentid: "1718616922481-col-2",
      //           elementid: "1718616970411",
      //           elementtype: "customDate",
      //         },
      //       ],
      //       colpos: 2,
      //       parentid: "1718616922481-columns",
      //       elementid: "1718616922481-col-2",
      //       elementtype: "column",
      //       colsizeclass: "col-md-6",
      //     },
      //   ],
      //   colsize: 2,
      //   parentid: "section-1718616917457-form",
      //   elementid: "1718616922481",
      //   elementtype: "columns",
      // },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616936763-col-2",
                elementid: "1718616984561",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616936763-col-1",
                elementid: "1718616976561",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616936763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616939763-col-1",
                elementid: "1718616994627",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616939763-col-2",
                elementid: "1718617002793",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616939763",
        elementtype: "columns",
      },
      // {
      //   child: [
      //     {
      //       child: [
      //         {
      //           parentid: "1718616942462-col-1",
      //           elementid: "1718617011709",
      //           elementtype: "number",
      //         },
      //       ],
      //       colpos: 1,
      //       parentid: "1718616942462-columns",
      //       elementid: "1718616942462-col-1",
      //       elementtype: "column",
      //       colsizeclass: "col-md-6",
      //     },
      //     {
      //       child: [
      //         {
      //           parentid: "1718616942462-col-2",
      //           elementid: "1718617014275",
      //           elementtype: "number",
      //         },
      //       ],
      //       colpos: 2,
      //       parentid: "1718616942462-columns",
      //       elementid: "1718616942462-col-2",
      //       elementtype: "column",
      //       colsizeclass: "col-md-6",
      //     },
      //   ],
      //   colsize: 2,
      //   parentid: "section-1718616917457-form",
      //   elementid: "1718616942462",
      //   elementtype: "columns",
      // },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616955479-col-1",
                elementid: "1718617024542",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616955479-col-2",
                elementid: "1718617031258",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616955479",
        elementtype: "columns",
      },
      {
        child: [
          // {
          //   child: [
          //     {
          //       parentid: "1718616961228-col-1",
          //       elementid: "1718617038957",
          //       elementtype: "customSelect",
          //     },
          //   ],
          //   colpos: 1,
          //   parentid: "1718616961228-columns",
          //   elementid: "1718616961228-col-1",
          //   elementtype: "column",
          //   colsizeclass: "col-md-6",
          // },
          {
            child: [],
            colpos: 2,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718616917457",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let OrderEditDetailsModalLayoutJSON = [
  {
    name: "Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1718616922481-col-1",
                elementid: "1718616967444",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616922481-columns",
            elementid: "1718616922481-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616922481-col-2",
                elementid: "1718616970411",
                elementtype: "customDate",
              },
            ],
            colpos: 2,
            parentid: "1718616922481-columns",
            elementid: "1718616922481-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616922481",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616936763-col-1",
                elementid: "1718616976561",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616936763-col-2",
                elementid: "1718616984561",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616936763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616939763-col-1",
                elementid: "1718616994627",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616939763-col-2",
                elementid: "1718617002793",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616939763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616942462-col-1",
                elementid: "1718617011709",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616942462-columns",
            elementid: "1718616942462-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616942462-col-2",
                elementid: "1718617014275",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616942462-columns",
            elementid: "1718616942462-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616942462",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616955479-col-1",
                elementid: "1718617024542",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616955479-col-2",
                elementid: "1718617031258",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616955479",
        elementtype: "columns",
      },

      // new rewnewal columns start

      {
        child: [
          {
            child: [
              {
                parentid: "1718616970419-col-1",
                elementid: "1718616970419",
                elementtype: "customDate",
              },
            ],
            colpos: 1,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718617038989-col-2",
                elementid: "1718617038989",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
      },

      {
        child: [
          {
            child: [
              {
                parentid: "1718616961228-col-1",
                elementid: "1718617038957",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718617035555-col-1",
                elementid: "1718617035555",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
        colsizeclass: "col-md-6",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718617038959-col-1",
                elementid: "1718617038959",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718617038958-col-2",
                elementid: "1718617038958",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718617038952-col-1",
                elementid: "1718617038952",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616961228-col-1",
                elementid: "1718617038951",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
        colsizeclass: "col-md-6",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718617038959-col-1",
                elementid: "1718617038962",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616961228-col-1",
                elementid: "1718617038953",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
        colsizeclass: "col-md-6",
      },

      {
        child: [
          {
            child: [
              {
                parentid: "1718617038959-col-1",
                elementid: "1718617038954",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },

        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
      },
    ],

    // renewal columns end
    parentid: "myTabContent",
    elementid: "section-1718616917457",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let BillingDetailsModalLayoutJSON = [
  {
    name: "Details",
    child: [
      {
        child: [
          // {
          //   child: [
          //     {
          //       parentid: "1718616922481-col-1",
          //       elementid: "1718616967444",
          //       elementtype: "textfield",
          //     },
          //   ],
          //   colpos: 1,
          //   parentid: "1718616922481-columns",
          //   elementid: "1718616922481-col-1",
          //   elementtype: "column",
          //   colsizeclass: "col-md-6",
          // },
          // {
          //   child: [
          //     {
          //       parentid: "1718616922481-col-2",
          //       elementid: "1718616970411",
          //       elementtype: "textfield",
          //     },
          //   ],
          //   colpos: 2,
          //   parentid: "1718616922481-columns",
          //   elementid: "1718616922481-col-2",
          //   elementtype: "column",
          //   colsizeclass: "col-md-6",
          // },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616922481",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616936763-col-1",
                elementid: "1718616976561",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616936763-col-2",
                elementid: "1718616984561",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616936763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616939763-col-1",
                elementid: "1718616976561",
                elementtype: "email",
              },
            ],
            colpos: 1,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616939763-col-2",
                elementid: "1718616994627",
                elementtype: "phoneNumber",
              },
            ],
            colpos: 2,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616939763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616942462-col-1",
                elementid: "1718617011709",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616942462-columns",
            elementid: "1718616942462-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616942462-col-2",
                elementid: "1718617014275",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616942462-columns",
            elementid: "1718616942462-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616942462",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616955479-col-1",
                elementid: "1718617024542",
                elementtype: "number",
              },
            ],
            colpos: 1,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616955479-col-2",
                elementid: "1718617031258",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616955479",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616961228-col-1",
                elementid: "1718617038957",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616961228-col-2",
                elementid: "1718617041258",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718616917457",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let BillingEditDetailsModalLayoutJSON = [
  {
    name: "Details",
    child: [
      {
        child: [
          {
            child: [],
            colpos: 1,
            parentid: "1718616922481-columns",
            elementid: "1718616922481-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          // {
          //   child: [
          //     {
          //       parentid: "1718616922481-col-2",
          //       elementid: "1718616970411",
          //       elementtype: "textfield",
          //     },
          //   ],
          //   colpos: 2,
          //   parentid: "1718616922481-columns",
          //   elementid: "1718616922481-col-2",
          //   elementtype: "column",
          //   colsizeclass: "col-md-6",
          // },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616922481",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616936763-col-1",
                elementid: "1718616976561",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616936763-col-2",
                elementid: "1718616970411",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616936763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616939763-col-1",
                elementid: "1718616976561",
                elementtype: "email",
              },
            ],
            colpos: 1,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616939763-col-2",
                elementid: "1718616994627",
                elementtype: "phoneNumber",
              },
            ],
            colpos: 2,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616939763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616942462-col-1",
                elementid: "1718617011709",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616942462-columns",
            elementid: "1718616942462-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616942462-col-2",
                elementid: "1718617014275",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616942462-columns",
            elementid: "1718616942462-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616942462",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616955479-col-1",
                elementid: "1718617024542",
                elementtype: "number",
              },
            ],
            colpos: 1,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616955479-col-2",
                elementid: "1718617031258",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616955479",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616961228-col-1",
                elementid: "1718617038957",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616961228-col-2",
                elementid: "1718617041258",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718616917457",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let DocumentLayoutJSON = [
  {
    name: "New",
    child: [
      {
        parentid: "section-1720177232612-form",
        elementid: "1720177249476",
        elementtype: "documentFile",
      },
      {
        parentid: "section-1720177232612-form",
        elementid: "1720177264442",
        elementtype: "documentFile",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1720177232612",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

// export let PolicyModalLayoutJSON = [
//   {
//     name: "Details",
//     child: [
//       {
//         child: [
//           {
//             child: [
//               {
//                 child: [
//                   {
//                     parentid: "1717412292824-col-1",
//                     elementid: "1717412302140",
//                     elementtype: "textfield",
//                   },
//                 ],
//                 colpos: 1,
//                 parentid: "1717412292824-columns",
//                 elementid: "1717412292824-col-1",
//                 elementtype: "column",
//                 colsizeclass: "col-md-6",
//               },
//               {
//                 child: [
//                   {
//                     parentid: "1717412292824-col-2",
//                     elementid: "1717412308306",
//                     elementtype: "textfield",
//                   },
//                 ],
//                 colpos: 2,
//                 parentid: "1717412292824-columns",
//                 elementid: "1717412292824-col-2",
//                 elementtype: "column",
//                 colsizeclass: "col-md-6",
//               },
//             ],
//             colsize: 2,
//             parentid: "1717412274041-fieldset-body",
//             elementid: "1717412292824",
//             elementtype: "columns",
//           },
//           {
//             child: [
//               {
//                 child: [
//                   {
//                     parentid: "1717412297658-col-1",
//                     elementid: "1717412315194",
//                     elementtype: "customSelect",
//                   },
//                 ],
//                 colpos: 1,
//                 parentid: "1717412297658-columns",
//                 elementid: "1717412297658-col-1",
//                 elementtype: "column",
//                 colsizeclass: "col-md-6",
//               },
//               {
//                 child: [],
//                 colpos: 2,
//                 parentid: "1717412297658-columns",
//                 elementid: "1717412297658-col-2",
//                 elementtype: "column",
//                 colsizeclass: "col-md-6",
//               },
//             ],
//             colsize: 2,
//             parentid: "1717412274041-fieldset-body",
//             elementid: "1717412297658",
//             elementtype: "columns",
//           },
//         ],
//         parentid: "section-1716786817440-form",
//         elementid: "1717412274041",
//         elementtype: "fieldset",
//       },
//       {
//         child: [
//           {
//             child: [
//               {
//                 child: [
//                   {
//                     parentid: "1717412338444-col-1",
//                     elementid: "1717412375477",
//                     elementtype: "textfield",
//                   },
//                 ],
//                 colpos: 1,
//                 parentid: "1717412338444-columns",
//                 elementid: "1717412338444-col-1",
//                 elementtype: "column",
//                 colsizeclass: "col-md-6",
//               },
//               {
//                 child: [
//                   {
//                     parentid: "1717412338444-col-2",
//                     elementid: "1717412387761",
//                     elementtype: "email",
//                   },
//                 ],
//                 colpos: 2,
//                 parentid: "1717412338444-columns",
//                 elementid: "1717412338444-col-2",
//                 elementtype: "column",
//                 colsizeclass: "col-md-6",
//               },
//             ],
//             colsize: 2,
//             parentid: "1717412322677-fieldset-body",
//             elementid: "1717412338444",
//             elementtype: "columns",
//           },
//           {
//             child: [
//               {
//                 child: [
//                   {
//                     parentid: "1717412346075-col-1",
//                     elementid: "1717412405877",
//                     elementtype: "phoneNumber",
//                   },
//                 ],
//                 colpos: 1,
//                 parentid: "1717412346075-columns",
//                 elementid: "1717412346075-col-1",
//                 elementtype: "column",
//                 colsizeclass: "col-md-6",
//               },
//               {
//                 child: [
//                   {
//                     parentid: "1717412346075-col-2",
//                     elementid: "1717412412343",
//                     elementtype: "textfield",
//                   },
//                 ],
//                 colpos: 2,
//                 parentid: "1717412346075-columns",
//                 elementid: "1717412346075-col-2",
//                 elementtype: "column",
//                 colsizeclass: "col-md-6",
//               },
//             ],
//             colsize: 2,
//             parentid: "1717412322677-fieldset-body",
//             elementid: "1717412346075",
//             elementtype: "columns",
//           },
//           {
//             child: [
//               {
//                 child: [
//                   {
//                     parentid: "1717412351926-col-1",
//                     elementid: "1717412415059",
//                     elementtype: "textfield",
//                   },
//                 ],
//                 colpos: 1,
//                 parentid: "1717412351926-columns",
//                 elementid: "1717412351926-col-1",
//                 elementtype: "column",
//                 colsizeclass: "col-md-6",
//               },
//               {
//                 child: [],
//                 colpos: 2,
//                 parentid: "1717412351926-columns",
//                 elementid: "1717412351926-col-2",
//                 elementtype: "column",
//                 colsizeclass: "col-md-6",
//               },
//             ],
//             colsize: 2,
//             parentid: "1717412322677-fieldset-body",
//             elementid: "1717412351926",
//             elementtype: "columns",
//           },
//         ],
//         parentid: "section-1716786817440-form",
//         elementid: "1717412322677",
//         elementtype: "fieldset",
//       },
//     ],
//     parentid: "myTabContent",
//     elementid: "section-1716786817440",
//     description: "",
//     elementtype: "section",
//     "section-type": "form",
//     linkedentitytype: -1,
//   },
// ];
export let PolicyModalLayoutJSON = [
  {
    name: "Policy Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "col-1",
                elementid: 1717412308306,
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "col-2",
                elementid: 1717412315194,
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        elementtype: "columns",
        colsize: 2,
      },
      {
        child: [
          {
            child: [
              {
                parentid: "col-1",
                elementid: 1717412405877,
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "col-2",
                elementid: 1717412415059,
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        elementtype: "columns",
        colsize: 2,
      },
      {
        child: [
          {
            child: [
              {
                parentid: "col-1",
                elementid: 1717412387761,
                elementtype: "customDate",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-4",
          },
          {
            child: [
              {
                parentid: "col-2",
                elementid: 1717412387762,
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            elementtype: "column",
            colsizeclass: "col-md-4",
          },
          {
            child: [
              {
                parentid: "col-3",
                elementid: 1717412274041,
                elementtype: "customDate",
              },
            ],
            colpos: 3,
            elementtype: "column",
            colsizeclass: "col-md-4",
          },
        ],
        elementtype: "columns",
        colsize: 3,
      },
      {
        child: [
          {
            child: [
              {
                parentid: "col-2",
                elementid: 1717412322677,
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "col-1",
                elementid: 1717412412343,
                elementtype: "customDate",
              },
            ],
            colpos: 2,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        elementtype: "columns",
        colsize: 2,
      },
      {
        child: [
          {
            child: [
              {
                parentid: "col-2",
                elementid: 1717412322777,
                elementtype: "customDate",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "col-1",
                elementid: 17174124127771,
                elementtype: "customDate",
              },
            ],
            colpos: 2,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        elementtype: "columns",
        colsize: 2,
      },
      {
        child: [
          {
            child: [
              {
                parentid: "col-1",
                elementid: 17174124127779,
                elementtype: "customDate",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "col-2",
                elementid: 17174124127782,
                elementtype: "customDate",
              },
            ],
            colpos: 2,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        elementtype: "columns",
        colsize: 2,
      },
      {
        child: [
          {
            child: [
              {
                parentid: "col-1",
                elementid: 1717412405878,
                elementtype: "file",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-12",
          },

        ],
        elementtype: "columns",
        colsize: 2,
      },
      // {
      //   child: [

      //     {
      //       child: [
      //         {
      //           parentid: "col-2",
      //           elementid: 1717412292824,
      //           elementtype: "documentFile",
      //         },
      //       ],
      //       colpos: 2,
      //       elementtype: "column",
      //       colsizeclass: "col-md-12",
      //     },
      //   ],
      //   elementtype: "columns",
      //   colsize: 2,
      // },
      {
        child: [
          {
            child: [
              {
                parentid: "col-1",
                elementid: 1717412351926,
                elementtype: "textarea",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-12",
          },
        ],
        elementtype: "columns",
        colsize: 1,
      },
    ],
  },
];

export let PolicyDocumentLayoutJSON = [
  {
    name: "New",
    child: [
      {
        parentid: "section-1720177232612-form",
        elementid: "1717412405877",
        elementtype: "documentFile",
      },
      // {
      //   parentid: "section-1720177232612-form",
      //   elementid: "1717412292824",
      //   elementtype: "documentFile",
      // },
    ],
    parentid: "myTabContent",
    elementid: "section-1720177232612",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
